import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import Select from "react-select";
import "react-select/dist/react-select.css";
import EditTemplate from "./utilities/EditTemplate";
import AddTemplateModal from "./utilities/AddTemplateModal";

const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class RdvTemplates extends React.Component {
  state = {
    selectedOption: "",
    isModalOpen: false
  };
  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  toggleModal = () => {
    setTimeout(() => {
      this.setState({
        isModalOpen: !this.state.isModalOpen
      });
    }, 500);
  };

  setSelectedOption = option => {
    this.setState({ selectedOption: option });
    this.props.allDayTemplatesQuery.refetch();
  };

  renderSelectedTemplate = () => {
    return (
      <EditTemplate
        doctorId={this.props.doctorId}
        templateId={this.state.selectedOption.id}
        refetchTemplates={this.props.allDayTemplatesQuery.refetch}
        setSelectedOption={this.setSelectedOption}
      />
    );
  };

  renderDropDown = () => {
    const { selectedOption } = this.state;
    //  const value = selectedOption && selectedOption.value;

    if (this.props.allDayTemplatesQuery.loading) {
      return (
        <tr>
          <td>Loading</td>
        </tr>
      );
    }
    if (this.props.allDayTemplatesQuery.allDayTemplates === undefined) {
      return null;
    }

    return (
      <Select
        name="form-field-name"
        value={selectedOption}
        valueKey="id"
        placeholder="Sélectionnez un template"
        labelKey="name"
        clearable={false}
        onChange={this.handleChange}
        options={this.props.allDayTemplatesQuery.allDayTemplates}
      />
    );
  };

  render() {
    let selectedTemplate =
      this.state.selectedOption === "" || this.state.selectedOption === null
        ? ""
        : this.renderSelectedTemplate();
    if (this.props.allDayTemplatesQuery.loading) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="columns is-centered">
            <div className="column is-4">{this.renderDropDown()}</div>
            <div className="column is-2">
              <a onClick={this.toggleModal}>nouveau template</a>
            </div>
          </div>
          {selectedTemplate}
          <AddTemplateModal
            isModalOpen={this.state.isModalOpen}
            doctorId={this.props.doctorId}
            toggleModal={this.toggleModal}
            allDayTemplates={this.props.allDayTemplatesQuery.allDayTemplates}
            setSelectedOption={this.setSelectedOption}
          />
        </div>
      );
    }
  }
}
/*
  authenticateUser = async () => {
    const { email, password } = this.state;

    const response = await this.props.authenticateUserMutation({
      variables: { email, password }
    });
    localStorage.setItem(
      "graphcoolToken",
      response.data.authenticateUser.token
    );
    this.props.history.replace("/");
  };
}
*/
const ALL_DAYTEMPLATES_QUERY = gql`
  query AllDayTemplatesQuery($doctorId: ID!) {
    allDayTemplates(
      filter: { doctor: { id: $doctorId } }
      orderBy: createdAt_ASC
    ) {
      id
      name
    }
  }
`;

export default graphql(ALL_DAYTEMPLATES_QUERY, {
  name: "allDayTemplatesQuery",
  options: ({ doctorId }) => ({ variables: { doctorId } })
})(RdvTemplates);



// WEBPACK FOOTER //
// ./src/components/RdvTemplates.js